<template>
  <div
    id="conteudo-acao"
    v-if="!loading && dadosAcaoResponse"
    v-show="!telaAberta"
  >
    <Breadcrumb :items="breadcrumbItems" />

    <!-- MENU SUPERIOR -->
    <section id="menu-container">
      <div id="menus">
        <div class="item">
          <a>Central PREX</a>
        </div>
      </div>
    </section>

    <!-- CONTEÚDO DINÂMICO COM LAYOUT CENTRAL PREX -->
    <div id="conteudo-dinamico">
      <div class="central-layout">
        <!-- MENU LATERAL -->
        <div class="menu-lateral">
          <div
            class="item-lateral"
            :class="{ ativo: secaoAtiva === 'sem-nome-1' }"
            @click="secaoAtiva = 'sem-nome-1'"
          >
            Usuários
          </div>
          <div
            class="item-lateral"
            :class="{ ativo: secaoAtiva === 'noticias' }"
            @click="secaoAtiva = 'noticias'"
          >
            Noticias
          </div>
          <div
            class="item-lateral"
            :class="{ ativo: secaoAtiva === 'sem-nome-2' }"
            @click="secaoAtiva = 'sem-nome-2'"
          >
            Parcerias
          </div>
          <div
            class="item-lateral"
            :class="{ ativo: secaoAtiva === 'importacao-sigaa' }"
            @click="secaoAtiva = 'importacao-sigaa'"
          >
            Importação de dados SIGAA
          </div>
          <div
            class="item-lateral"
            :class="{ ativo: secaoAtiva === 'gerenciar-destaques' }"
            @click="secaoAtiva = 'gerenciar-destaques'"
          >
            Carrossel de Destaques
          </div>
        </div>

        <!-- ÁREA DE CONTEÚDO -->
        <div
          class="conteudo-central"
          ref="conteudoRef"
        >
          <!-- SEÇÃO: USUÁRIOS -->
          <div
            v-if="secaoAtiva === 'sem-nome-1'"
            class="usuarios-wrapper"
          >
            <!-- LOADING -->
            <Carregamento
              v-if="
                (loadingUsuarios || loadingCoordenadores) &&
                usuarios.length === 0 &&
                coordenadores.length === 0
              "
              :mensagemCarregamento="'Carregando usuários'"
            />

            <!-- ESTADO VAZIO -->
            <div
              v-else-if="
                !loadingUsuarios &&
                !loadingCoordenadores &&
                usuarios.length === 0 &&
                coordenadores.length === 0
              "
              class="sem-noticias"
            >
              <p>Nenhum usuário encontrado.</p>
            </div>

            <!-- GRID DE TABELAS SIDE-BY-SIDE -->
            <template v-else>
              <div class="titulo-gerenciamento">
                <h3>Menu de Gerenciamento de Credenciais</h3>
                <p>
                  Arraste os usuários entre as tabelas para adicionar ou remover
                  perfis
                </p>
              </div>
              <div class="tabelas-grid">
                <!-- PAINEL ESQUERDO: COORDENADORIA/PREX -->
                <div
                  class="tabela-painel"
                  :class="{ 'drag-over': dragOverPainel === 'coordenadores' }"
                  @dragover.prevent="dragOverPainel = 'coordenadores'"
                  @dragleave="dragOverPainel = null"
                  @drop="onDropCoordenadores($event)"
                >
                  <div class="painel-header">
                    <h5 class="painel-titulo">Coordenadoria / PREX</h5>
                  </div>
                  <div class="painel-filtro">
                    <div class="busca-campo">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="rgba(255,255,255,0.5)"
                        stroke-width="2"
                      >
                        <path
                          d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
                        />
                        <polyline points="9 22 9 12 15 12 15 22" />
                      </svg>
                      <select
                        v-model="buscaUnidadeCoord"
                        class="select-busca-unidade"
                        @change="buscarUsuarios(0)"
                      >
                        <option
                          v-for="unidade in unidadesPredefinidas"
                          :key="unidade.id"
                          :value="unidade.nome"
                        >
                          {{ unidade.nome }}
                        </option>
                        <option value="PREX">PREX</option>
                      </select>
                    </div>
                  </div>
                  <div class="tabela-scroll">
                    <div
                      v-if="coordenadores.length === 0"
                      class="tabela-vazia"
                    >
                      <p>Nenhum coordenador encontrado.</p>
                    </div>
                    <table
                      v-else
                      class="tabela-usuarios"
                    >
                      <thead>
                        <tr>
                          <th>Nome</th>
                          <th>E-mail</th>
                          <th>Regras</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="usuario in coordenadores"
                          :key="usuario.id"
                          draggable="true"
                          :class="{
                            dragging: dragItem?.id === usuario.id,
                            'linha-pendente-remover':
                              pendentesRebaixar.includes(usuario.id),
                          }"
                          @dragstart="
                            onDragStart($event, usuario, 'coordenadores')
                          "
                          @dragend="onDragEnd"
                        >
                          <td>{{ usuario.nome }}</td>
                          <td>{{ usuario.email }}</td>
                          <td class="celula-regras">
                            <span
                              v-for="regra in usuario.regras"
                              :key="regra"
                              class="badge-regra"
                              :class="classeBadgeRegra(regra)"
                            >
                              {{ regra }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="painel-footer">
                    <div
                      class="carregar-mais-container"
                      v-if="temMaisCoordenadores"
                    >
                      <button
                        class="btn-carregar-mais"
                        @click="carregarMaisCoordenadores"
                        :disabled="loadingMaisCoordenadores"
                      >
                        <span
                          v-if="loadingMaisCoordenadores"
                          class="loading-dots"
                        >
                          <span></span><span></span><span></span>
                        </span>
                        <span v-else>Carregar mais</span>
                      </button>
                      <span class="info-paginacao">
                        {{ coordenadores.length }} de {{ totalCoordenadores }}
                      </span>
                    </div>
                    <div
                      class="botoes-acao"
                      v-if="pendentesRebaixar.length > 0"
                    >
                      <button
                        class="btn-cancelar-mudancas"
                        @click="desfazerRebaixamentos"
                        :disabled="salvandoRebaixar"
                      >
                        Desfazer
                      </button>
                      <button
                        class="btn-salvar-mudancas"
                        @click="iniciarSalvamento('rebaixar')"
                        :disabled="salvandoRebaixar"
                      >
                        {{
                          salvandoRebaixar
                            ? "Salvando..."
                            : `Salvar Mudanças (${pendentesRebaixar.length})`
                        }}
                      </button>
                    </div>
                  </div>
                </div>

                <!-- COLUNA CENTRAL: INSTRUÇÕES -->
                <div class="instrucoes-drag">
                  <div class="instrucao-item">
                    <span class="seta">←</span>
                    <p>
                      Arraste para esta tabela para
                      <strong>dar credencial</strong>
                    </p>
                  </div>
                  <div class="instrucao-separador"></div>
                  <div class="instrucao-item">
                    <span class="seta">→</span>
                    <p>
                      Arraste para esta tabela para
                      <strong>remover credencial</strong>
                    </p>
                  </div>
                </div>

                <!-- PAINEL DIREITO: USUÁRIOS -->
                <div
                  class="tabela-painel"
                  :class="{ 'drag-over': dragOverPainel === 'usuarios' }"
                  @dragover.prevent="dragOverPainel = 'usuarios'"
                  @dragleave="dragOverPainel = null"
                  @drop="onDropUsuarios($event)"
                >
                  <div class="painel-header">
                    <h5 class="painel-titulo">Usuários</h5>
                  </div>
                  <div class="painel-filtro">
                    <div class="busca-campo">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="rgba(255,255,255,0.5)"
                        stroke-width="2"
                      >
                        <circle
                          cx="11"
                          cy="11"
                          r="8"
                        />
                        <path d="m21 21-4.3-4.3" />
                      </svg>
                      <input
                        type="text"
                        v-model="buscaNomeUsuarios"
                        placeholder="Buscar por nome..."
                        @keydown.enter="buscarUsuariosPadrao(0)"
                      />
                    </div>
                  </div>
                  <div class="tabela-scroll">
                    <div
                      v-if="usuariosPadrao.length === 0"
                      class="tabela-vazia"
                    >
                      <p>Nenhum usuário encontrado.</p>
                    </div>
                    <table
                      v-else
                      class="tabela-usuarios"
                    >
                      <thead>
                        <tr>
                          <th>Nome</th>
                          <th>E-mail</th>
                          <th>Regras</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="usuario in usuariosPadrao"
                          :key="usuario.id"
                          draggable="true"
                          :class="{
                            dragging: dragItem?.id === usuario.id,
                            'linha-pendente-promover':
                              pendentesPromover.includes(usuario.id),
                          }"
                          @dragstart="onDragStart($event, usuario, 'usuarios')"
                          @dragend="onDragEnd"
                        >
                          <td>{{ usuario.nome }}</td>
                          <td>{{ usuario.email }}</td>
                          <td class="celula-regras">
                            <span
                              v-for="regra in usuario.regras"
                              :key="regra"
                              class="badge-regra"
                              :class="classeBadgeRegra(regra)"
                            >
                              {{ regra }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="painel-footer">
                    <div
                      class="carregar-mais-container"
                      v-if="temMaisUsuarios"
                    >
                      <button
                        class="btn-carregar-mais"
                        @click="carregarMaisUsuarios"
                        :disabled="loadingMaisUsuarios"
                      >
                        <span
                          v-if="loadingMaisUsuarios"
                          class="loading-dots"
                        >
                          <span></span><span></span><span></span>
                        </span>
                        <span v-else>Carregar mais</span>
                      </button>
                      <span class="info-paginacao">
                        {{ usuariosPadrao.length }} de {{ totalUsuarios }}
                      </span>
                    </div>
                    <div
                      class="botoes-acao"
                      v-if="pendentesPromover.length > 0"
                    >
                      <button
                        class="btn-cancelar-mudancas"
                        @click="desfazerPromocoes"
                        :disabled="salvandoPromover"
                      >
                        Desfazer
                      </button>
                      <button
                        class="btn-salvar-mudancas promover"
                        @click="iniciarSalvamento('promover')"
                        :disabled="salvandoPromover"
                      >
                        {{
                          salvandoPromover
                            ? "Salvando..."
                            : `Salvar Mudanças (${pendentesPromover.length})`
                        }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>

          <!-- SEÇÕES SEM NOME (placeholders para seções futuras) -->
          <div
            v-if="
              secaoAtiva !== 'noticias' &&
              secaoAtiva !== 'sem-nome-1' &&
              secaoAtiva !== 'importacao-sigaa' &&
              secaoAtiva !== 'gerenciar-destaques'
            "
            class="secao-vazia"
          >
            <p>Conteúdo em breve.</p>
          </div>

          <!-- SEÇÃO: IMPORTAÇÃO DE DADOS SIGAA -->
          <div
            v-if="secaoAtiva === 'importacao-sigaa'"
            class="importacao-wrapper"
          >
            <ImportacaoSigaaView />
          </div>

          <!-- SEÇÃO: GERENCIAR CARROSSEL DE DESTAQUES -->
          <div
            v-if="secaoAtiva === 'gerenciar-destaques'"
            class="destaques-wrapper"
          >
            <GerenciarDestaques />
          </div>

          <!-- SEÇÃO: CENTRAL PREX - LISTAGEM DE NOTÍCIAS -->
          <div
            v-if="secaoAtiva === 'noticias'"
            class="noticias-wrapper"
          >
            <div class="titulo-gerenciamento">
              <h3>Painel de Autorização de Notícias</h3>
              <p>
                Avalie as notícias enviadas pelas ações de extensão para aprovar
                ou rejeitar sua publicação
              </p>
            </div>

            <Carregamento
              v-if="loadingNoticias && noticiasPrex.length === 0"
              :mensagemCarregamento="'Carregando notícias'"
            />

            <div
              v-else-if="noticiasPrex.length === 0"
              class="sem-noticias"
            >
              <p>Nenhuma notícia encontrada.</p>
            </div>

            <template v-else>
              <div
                v-for="noticia in noticiasPrex"
                :key="noticia.id"
                class="noticia-card"
              >
                <div class="noticia-card-left">
                  <span
                    class="badge"
                    :class="
                      classeStatus(
                        noticia.statusDescricao ||
                          noticia.tipoStatus ||
                          noticia.status
                      )
                    "
                  >
                    {{
                      formatarStatus(
                        noticia.statusDescricao ||
                          noticia.tipoStatus ||
                          noticia.status
                      )
                    }}
                  </span>
                  <img
                    v-if="noticia.imagemUrl"
                    :src="noticia.imagemUrl"
                    :alt="noticia.titulo"
                    class="noticia-thumb-left"
                  />
                </div>
                <div class="noticia-card-center">
                  <h4 class="titulo-noticia">{{ noticia.titulo }}</h4>
                  <p class="noticia-desc">{{ noticia.texto }}</p>
                  <div class="noticia-card-meta">
                    <span class="noticia-autor"
                      >Por: {{ noticia.autorPublicacaoNome }}</span
                    >
                    <div
                      class="tags"
                      v-if="noticia.palavrasChave?.length"
                    >
                      <span
                        class="tag"
                        v-for="(palavra, index) in noticia.palavrasChave"
                        :key="index"
                      >
                        {{ palavra }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="noticia-card-right">
                  <button
                    class="btn-detalhes"
                    @click="verDetalhes(noticia)"
                  >
                    Ver detalhes
                  </button>
                </div>
              </div>

              <!-- BOTÃO CARREGAR MAIS -->
              <div
                class="carregar-mais-container"
                v-if="temMaisNoticias"
              >
                <button
                  class="btn-carregar-mais"
                  @click="carregarMais"
                  :disabled="loadingMais"
                >
                  <span
                    v-if="loadingMais"
                    class="loading-dots"
                  >
                    <span></span><span></span><span></span>
                  </span>
                  <span v-else>Carregar mais</span>
                </button>
                <span class="info-paginacao">
                  Exibindo {{ noticiasPrex.length }} de
                  {{ totalElementos }} notícias
                </span>
              </div>

              <div
                class="fim-lista"
                v-else-if="noticiasPrex.length > 0"
              >
                <span
                  >Todas as notícias foram carregadas ({{
                    totalElementos
                  }})</span
                >
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>

  <NoticiaViewPrex
    v-if="noticiaDetalheAberta"
    :noticiaId="noticiaDetalheSelecionada?.id"
    :noticiaObjeto="noticiaDetalheSelecionada"
    :mostrarBotoes="true"
    @fechar="fecharDetalheNoticia"
    @aceita="onNoticiaAtualizada"
    @rejeitada="onNoticiaAtualizada"
  />

  <ModalConfirmarSenha
    :mostrar="modalSenhaVisivel"
    :carregando="verificandoSenha"
    :erro="erroSenha"
    @cancelar="fecharModalSenha"
    @confirmar="onConfirmarSenha"
  />

  <Carregamento v-if="loading" />
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { formatarEnum } from "@/utils/FormatarEntradas";
import noticiaService from "@/service/noticiaService";
import usuariosService from "@/service/usuariosService";
import ImportacaoSigaaView from "@/views/usuarios/ImportacaoSigaaView.vue";
import GerenciarDestaques from "@/components/noticias/GerenciarDestaques.vue";
import NoticiaViewPrex from "@/views/noticias/NoticiaViewPrex.vue";

import Carregamento from "@/components/common/Carregamento.vue";
import ModalConfirmarSenha from "@/components/usuarios/ModalConfirmarSenha.vue";
import Breadcrumb from "@/components/common/Breadcrumb.vue";

const route = useRoute();
const router = useRouter();
const destaques = ref([]);

const loading = ref(false);
const loadingNoticias = ref(false);
const loadingMais = ref(false);
const dadosAcaoResponse = ref({});
const secaoAtiva = ref("noticias");
const telaAberta = ref(false);
const conteudoRef = ref(null);

const noticiasPrex = ref([]);
const paginaAtual = ref(0);
const totalElementos = ref(0);
const totalPaginas = ref(0);
const tamanhoPagina = 20;

// --- Estado da seção Usuários (tabela de usuários padrão) ---
const usuarios = ref([]);
const buscaNome = ref("");
const buscaUnidade = ref("");
const buscaNomeUsuarios = ref("");
const buscaUnidadeCoord = ref("SECRETARIA ACADEMICA/QUIXADA");
const loadingUsuarios = ref(false);
const loadingMaisUsuarios = ref(false);
const paginaUsuarios = ref(0);
const totalPaginasUsuarios = ref(0);
const totalUsuarios = ref(0);
const enviandoRegra = ref(false);

// Drag-and-drop state
const dragItem = ref(null);
const dragOrigem = ref(null);
const dragOverPainel = ref(null);
const pendentesPromover = ref([]);
const pendentesRebaixar = ref([]);
const salvandoPromover = ref(false);
const salvandoRebaixar = ref(false);
const tamanhoPaginaUsuarios = 15;

// --- Estado da seção Coordenadores (tabela separada) ---
const coordenadores = ref([]);
const loadingCoordenadores = ref(false);
const loadingMaisCoordenadores = ref(false);
const paginaCoordenadores = ref(0);
const totalPaginasCoordenadores = ref(0);
const totalCoordenadores = ref(0);

const unidadesPredefinidas = [
  {
    id: "1d55bd34-d289-47b5-8c19-ee20e36f8213",
    nome: "SECRETARIA ACADEMICA/QUIXADA",
  },
  {
    id: "39b80291-16b1-4597-a4b8-9cf8f9666edf",
    nome: "CAMPUS DA UFC EM SOBRAL/DIRETORIA",
  },
  {
    id: "84739aa6-d47d-46d4-8a52-f7fd29797239",
    nome: "CURSO DE CIENCIA DA COMPUTACAO/RUSSAS",
  },
  {
    id: "b0723e0d-03e0-4ebc-8593-631786dc1d35",
    nome: "CAMPUS DA UFC EM QUIXADA/DIRETORIA",
  },
  {
    id: "90d61a0a-0c4d-4647-902b-1fdee09fc760",
    nome: "SECRETARIA DO CAMPUS DA UFC EM QUIXADA",
  },
  {
    id: "21a376ac-4363-40b8-be8e-ef57d7493bd3",
    nome: "CAMPUS DA UFC DE RUSSAS",
  },
  {
    id: "8ba899b6-0e6b-4374-9071-ba39df180d83",
    nome: "CAMPUS DA UFC DE CRATEUS",
  },
  {
    id: "bfc4b527-abc5-42c5-9818-09d45d35c84a",
    nome: "COORD CURSO GRAD EM ENG DA COMP/SOBRAL",
  },
];

const temMaisUsuarios = computed(() => {
  return paginaUsuarios.value + 1 < totalPaginasUsuarios.value;
});

const temMaisCoordenadores = computed(() => {
  return paginaCoordenadores.value + 1 < totalPaginasCoordenadores.value;
});

const usuariosPadrao = computed(() => {
  return usuarios.value;
});

const breadcrumbItems = computed(() => {
  return [
    { label: "Início", to: "/" },
    { label: "Central Prex", to: "/central-prex" },
  ];
});

function classeBadgeRegra(regra) {
  const mapa = {
    COORDENADOR: "badge-coordenador",
    USUARIO: "badge-usuario",
    ALUNO: "badge-aluno",
    PREX: "badge-prex",
    COORDENADORIA: "badge-coordenadoria",
    ADMINISTRADOR: "badge-admin",
    LIDER: "badge-lider",
  };
  return mapa[regra] || "badge-default";
}

// Busca unificada: dispara as duas buscas (garante coordenadores primeiro para o filtro local funcionar)
async function buscarUsuarios(pagina = 0) {
  await buscarCoordenadoresLista(pagina);
  await buscarUsuariosPadrao(pagina);
}

async function buscarUsuariosPadrao(pagina = 0) {
  loadingUsuarios.value = true;
  paginaUsuarios.value = pagina;
  if (pagina === 0) usuarios.value = [];
  try {
    const response = await usuariosService.pesquisarUsuarios(
      pagina,
      tamanhoPaginaUsuarios,
      buscaNomeUsuarios.value,
      ""
    );
    let dadosUsuarios = response.content ?? [];

    // Filtro local para esconder os usuários que já são coordenadores na listagem esquerda
    dadosUsuarios = dadosUsuarios.filter(
      (u) => !coordenadores.value.find((c) => c.id === u.id)
    );

    if (pagina === 0) {
      usuarios.value = dadosUsuarios;
    } else {
      usuarios.value = [...usuarios.value, ...dadosUsuarios];
    }
    totalPaginasUsuarios.value = response.totalPages ?? 1;
    totalUsuarios.value = response.totalElements ?? 0;
    paginaUsuarios.value = response.number ?? pagina;
  } catch (error) {
    console.error("Erro ao buscar usuários:", error);
  } finally {
    loadingUsuarios.value = false;
  }
}

async function buscarCoordenadoresLista(pagina = 0) {
  loadingCoordenadores.value = true;
  paginaCoordenadores.value = pagina;
  if (pagina === 0) coordenadores.value = [];
  try {
    const isBuscaPrex = buscaUnidadeCoord.value === "PREX";

    const response = await usuariosService.pesquisarCoordenadores(
      pagina,
      tamanhoPaginaUsuarios,
      "",
      isBuscaPrex ? "" : buscaUnidadeCoord.value
    );

    let dados = response.content ?? [];

    if (isBuscaPrex) {
      dados = dados.filter((u) => u.regras && u.regras.includes("PREX"));
    }

    if (pagina === 0) {
      coordenadores.value = dados;
    } else {
      coordenadores.value = [...coordenadores.value, ...dados];
    }
    totalPaginasCoordenadores.value = response.totalPages ?? 1;
    totalCoordenadores.value = response.totalElements ?? 0;
    paginaCoordenadores.value = response.number ?? pagina;
  } catch (error) {
    console.error("Erro ao buscar coordenadores:", error);
  } finally {
    loadingCoordenadores.value = false;
  }
}

async function carregarMaisUsuarios() {
  if (loadingMaisUsuarios.value || !temMaisUsuarios.value) return;
  loadingMaisUsuarios.value = true;
  try {
    await buscarUsuariosPadrao(paginaUsuarios.value + 1);
  } finally {
    loadingMaisUsuarios.value = false;
  }
}

async function carregarMaisCoordenadores() {
  if (loadingMaisCoordenadores.value || !temMaisCoordenadores.value) return;
  loadingMaisCoordenadores.value = true;
  try {
    await buscarCoordenadoresLista(paginaCoordenadores.value + 1);
  } finally {
    loadingMaisCoordenadores.value = false;
  }
}

// --- Drag and Drop ---
function onDragStart(event, usuario, origem) {
  dragItem.value = usuario;
  dragOrigem.value = origem;
  event.dataTransfer.effectAllowed = "move";
  event.dataTransfer.setData("text/plain", usuario.id);
}

function onDragEnd() {
  dragItem.value = null;
  dragOrigem.value = null;
  dragOverPainel.value = null;
}

function onDropCoordenadores(event) {
  event.preventDefault();
  dragOverPainel.value = null;
  if (!dragItem.value || dragOrigem.value === "coordenadores") return;

  const usuario = dragItem.value;
  if (!pendentesPromover.value.includes(usuario.id)) {
    pendentesPromover.value.push(usuario.id);
    // Mover visualmente
    usuarios.value = usuarios.value.filter((u) => u.id !== usuario.id);
    coordenadores.value.unshift(usuario);
  }
  dragItem.value = null;
  dragOrigem.value = null;
}

function onDropUsuarios(event) {
  event.preventDefault();
  dragOverPainel.value = null;
  if (!dragItem.value || dragOrigem.value === "usuarios") return;

  const usuario = dragItem.value;
  if (!pendentesRebaixar.value.includes(usuario.id)) {
    pendentesRebaixar.value.push(usuario.id);
    // Mover visualmente
    coordenadores.value = coordenadores.value.filter(
      (c) => c.id !== usuario.id
    );
    usuarios.value.unshift(usuario);
  }
  dragItem.value = null;
  dragOrigem.value = null;
}

function desfazerPromocoes() {
  const movidos = coordenadores.value.filter((c) =>
    pendentesPromover.value.includes(c.id)
  );
  coordenadores.value = coordenadores.value.filter(
    (c) => !pendentesPromover.value.includes(c.id)
  );
  usuarios.value = [...movidos, ...usuarios.value];
  pendentesPromover.value = [];
}

function desfazerRebaixamentos() {
  const movidos = usuarios.value.filter((u) =>
    pendentesRebaixar.value.includes(u.id)
  );
  usuarios.value = usuarios.value.filter(
    (u) => !pendentesRebaixar.value.includes(u.id)
  );
  coordenadores.value = [...movidos, ...coordenadores.value];
  pendentesRebaixar.value = [];
}

const modalSenhaVisivel = ref(false);
const verificandoSenha = ref(false);
const erroSenha = ref("");
const acaoSenhaPendente = ref("");

function iniciarSalvamento(tipo) {
  acaoSenhaPendente.value = tipo;
  erroSenha.value = "";
  modalSenhaVisivel.value = true;
}

function fecharModalSenha() {
  modalSenhaVisivel.value = false;
  erroSenha.value = "";
}

async function onConfirmarSenha(senha) {
  verificandoSenha.value = true;
  erroSenha.value = "";
  try {
    const valida = await usuariosService.verificarSenha(senha);
    if (!valida) {
      erroSenha.value = "Senha incorreta. Tente novamente.";
      return;
    }
    fecharModalSenha();
    if (acaoSenhaPendente.value === "promover") {
      await executarPromocoes();
    } else if (acaoSenhaPendente.value === "rebaixar") {
      await executarRebaixamentos();
    }
  } catch (error) {
    erroSenha.value = "Erro ao validar senha.";
  } finally {
    verificandoSenha.value = false;
  }
}

async function executarPromocoes() {
  if (pendentesPromover.value.length === 0) return;
  salvandoPromover.value = true;
  try {
    const isPrex = buscaUnidadeCoord.value === "PREX";
    const regraParam = isPrex ? "PREX" : "COORDENADORIA";
    let unidadeIdParam = "";

    if (!isPrex) {
      const unidadeSelecionada = unidadesPredefinidas.find(
        (u) => u.nome === buscaUnidadeCoord.value
      );
      if (unidadeSelecionada) {
        unidadeIdParam = unidadeSelecionada.id;
      }
    }

    for (const id of pendentesPromover.value) {
      await usuariosService.promoverCoordenadoriaOuPrex(
        id,
        regraParam,
        unidadeIdParam
      );
    }
    alert(
      `${pendentesPromover.value.length} usuário(s) promovido(s) com sucesso!`
    );
    pendentesPromover.value = [];
    await buscarUsuariosPadrao(0);
    await buscarCoordenadoresLista(0);
  } catch (error) {
    console.error("Erro ao salvar promoções:", error);
    alert("Erro ao salvar mudanças.");
  } finally {
    salvandoPromover.value = false;
  }
}

async function executarRebaixamentos() {
  if (pendentesRebaixar.value.length === 0) return;
  salvandoRebaixar.value = true;
  try {
    const isPrex = buscaUnidadeCoord.value === "PREX";
    const byPrex = isPrex;
    const byUnidade = buscaUnidadeCoord.value !== "" && !isPrex;

    for (const id of pendentesRebaixar.value) {
      await usuariosService.rebaixarCoordenador(id, byUnidade, byPrex);
    }
    alert(
      `${pendentesRebaixar.value.length} coordenador(es) rebaixado(s) com sucesso!`
    );
    pendentesRebaixar.value = [];
    await buscarUsuariosPadrao(0);
    await buscarCoordenadoresLista(0);
  } catch (error) {
    console.error("Erro ao salvar rebaixamentos:", error);
    alert("Erro ao salvar mudanças.");
  } finally {
    salvandoRebaixar.value = false;
  }
}

// Estado do modal de tornar coordenador
const modalCoordenador = ref({
  visivel: false,
  usuario: null,
  unidadeId: "",
});

function abrirModalCoordenador(usuario) {
  modalCoordenador.value = {
    visivel: true,
    usuario: usuario,
    unidadeId: "",
  };
}

function fecharModalCoordenador() {
  modalCoordenador.value = {
    visivel: false,
    usuario: null,
    unidadeId: "",
  };
}

function confirmarTornarCoordenador() {
  const body = {
    unidadeId: modalCoordenador.value.unidadeId,
    usuarioId: modalCoordenador.value.usuario?.id,
  };
  // TODO: chamar o endpoint do backend quando estiver pronto
  // await usuariosService.tornarCoordenador(body.usuarioId, body.unidadeId);

  // Atualiza localmente para feedback visual
  const usuario = modalCoordenador.value.usuario;
  if (usuario && !usuario.regras.includes("COORDENADOR")) {
    usuario.regras.push("COORDENADOR");
  }
  fecharModalCoordenador();
}

async function removerCoordenador(usuario) {
  const confirmado = confirm(
    `Tem certeza que deseja remover "${usuario.nome}" como coordenador?`
  );
  if (!confirmado) return;

  enviandoRegra.value = true;
  try {
    const status = await usuariosService.rebaixarCoordenador(usuario.id);
    if (status === 200 || status === 204 || status === 201) {
      // Atualiza localmente para feedback visual
      const index = coordenadores.value.findIndex((c) => c.id === usuario.id);
      if (index > -1) {
        coordenadores.value.splice(index, 1);
      }

      // Remove a regra COORDENADOR localmente
      const regraIndex = usuario.regras.indexOf("COORDENADOR");
      if (regraIndex > -1) {
        usuario.regras.splice(regraIndex, 1);
      }

      // Adiciona na lista de usuários padrão se não estiver lá
      const userExists = usuarios.value.find((u) => u.id === usuario.id);
      if (!userExists) {
        usuarios.value.unshift(usuario);
      }

      alert("Coordenador removido com sucesso!");
    } else {
      alert("Erro ao remover coordenador.");
    }
  } catch (error) {
    console.error("Erro ao remover coordenador:", error);
    alert("Erro ao remover coordenador.");
  } finally {
    enviandoRegra.value = false;
  }
}

const dadosAcao = computed(() => {
  return (
    dadosAcaoResponse.value || {
      titulo: "Título Padrão",
      nomeCoordenador: "Coordenador Padrão",
      tipoAcao: "Projeto",
    }
  );
});

const temMaisNoticias = computed(() => {
  return paginaAtual.value + 1 < totalPaginas.value;
});

const mapeamentoRotas = {
  atividades: "Atividades",
  noticias: "Notícias",
  informacoes: "Informações",
  declaracoes: "Minhas Declarações",
  tarefas: "Tarefas",
  "central-coordenacao": "Central da Coordenação",
  "central-prex": "Central Prex",
};

const rotaAtual = computed(() => {
  const path = route.path;
  for (const rota of Object.keys(mapeamentoRotas)) {
    if (path.includes(rota)) return rota;
  }
  return "";
});

const nomeDaRotaAtual = computed(() => {
  return mapeamentoRotas[rotaAtual.value] || "Página Atual";
});

const podeNavegarParaRotaAtual = computed(() => {
  const rotasSemLink = [
    "cadastrar-atividade",
    "cadastrar-noticia",
    "cadastrar-tarefa",
  ];
  return !rotasSemLink.some((rota) => route.path.includes(rota));
});

function classeStatus(status) {
  if (!status) return "";
  const s = status.toLowerCase();
  if (s.includes("aguard") || s.includes("pendente")) return "pendente";
  if (s.includes("aprovad") || s.includes("autorizado")) return "aprovada";
  if (s.includes("rejeit") || s.includes("recusad")) return "rejeitada";
  return "pendente";
}

function formatarStatus(status) {
  if (!status) return "";
  const map = {
    PENDENTE: "Pendente",
    APROVADA: "Aprovada",
    REJEITADA: "Rejeitada",
    AGUARDANDO_AUTORIZACAO: "Pendente",
    AUTORIZADO: "Aprovada",
    RECUSADO: "Rejeitada",
  };
  return map[status] ?? status;
}

const noticiaDetalheAberta = ref(false);
const noticiaDetalheSelecionada = ref(null);

function verDetalhes(noticia) {
  noticiaDetalheSelecionada.value = noticia;
  noticiaDetalheAberta.value = true;
}

function fecharDetalheNoticia() {
  noticiaDetalheAberta.value = false;
  noticiaDetalheSelecionada.value = null;
}

function onNoticiaAtualizada() {
  fecharDetalheNoticia();
  buscarNoticiasPrex();
}

async function buscarNoticiasPrex() {
  loadingNoticias.value = true;
  paginaAtual.value = 0;
  noticiasPrex.value = [];
  try {
    const response = await noticiaService.getAutorizarNoticia(0, tamanhoPagina);
    console.log("Response de Noticias PREX:", response);
    // response esperado: { content: [...], totalElements: N, totalPages: N, number: N }
    noticiasPrex.value = response.content ?? response;
    totalElementos.value = response.totalElements ?? noticiasPrex.value.length;
    totalPaginas.value = response.totalPages ?? 1;
    paginaAtual.value = response.number ?? 0;
  } catch (error) {
    console.error("Erro ao buscar notícias:", error);
  } finally {
    loadingNoticias.value = false;
  }
}

async function carregarMais() {
  if (loadingMais.value || !temMaisNoticias.value) return;
  loadingMais.value = true;
  const proximaPagina = paginaAtual.value + 1;
  try {
    const response = await noticiaService.getAutorizarNoticia(
      proximaPagina,
      tamanhoPagina
    );
    const novasNoticias = response.content ?? response;
    noticiasPrex.value = [...noticiasPrex.value, ...novasNoticias];
    paginaAtual.value = response.number ?? proximaPagina;
    totalPaginas.value = response.totalPages ?? totalPaginas.value;
    totalElementos.value = response.totalElements ?? totalElementos.value;

    // Scroll suave até o fim do conteúdo atual
    await new Promise((r) => setTimeout(r, 100));
    if (conteudoRef.value) {
      conteudoRef.value.scrollTo({
        top: conteudoRef.value.scrollHeight,
        behavior: "smooth",
      });
    }
  } catch (error) {
    console.error("Erro ao carregar mais notícias:", error);
  } finally {
    loadingMais.value = false;
  }
}

let debounceBuscaUsuarios = null;
watch(buscaNomeUsuarios, () => {
  clearTimeout(debounceBuscaUsuarios);
  debounceBuscaUsuarios = setTimeout(() => {
    buscarUsuariosPadrao(0);
  }, 350);
});

watch(secaoAtiva, (nova) => {
  if (nova === "noticias") buscarNoticiasPrex();
  if (nova === "sem-nome-1") buscarUsuarios(0);
});

onMounted(() => {
  buscarNoticiasPrex();
});
</script>

<style scoped>
#conteudo-acao {
  display: block;
  background-color: #f5f4f9;
  padding: 20px 0;
  border-radius: 10px;
  border-bottom: 1px solid rgb(211, 211, 211);
}

#titulo {
  padding: 0 20px 20px 20px;
  border-radius: 10px 10px 0 0;
}

#titulo h2 {
  font-size: 1.8rem;
  color: #343a40;
  margin-bottom: 0.5rem;
}

#titulo h4 {
  font-size: 1rem;
  color: #6c757d;
  margin: 0;
}

#menu-container {
  padding: 0 20px;
}

#menus {
  display: flex;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 20px;
  width: 100%;
  border-radius: 5px;
  overflow: hidden;
  border: 1px solid #48298a !important;
}

.item {
  display: flex;
  flex: 1;
  min-width: 160px;
}

#menus .item a {
  width: 100%;
  border: none;
  padding: 12px 15px;
  font-size: 1rem;
  transition:
    background-color 0.3s ease,
    color 0.3s ease;
  color: white;
  background-color: #362065;
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  word-break: break-word;
  white-space: normal;
}

.ultimo-item a {
  border-right: none !important;
}

.opcao-selecionada a {
  background-color: white !important;
  color: black !important;
}

#conteudo-dinamico {
  padding: 0 20px;
  min-height: 50vh;
}

/* LAYOUT CENTRAL PREX */
.central-layout {
  display: flex;
  border: 1px solid #48298a;
  border-radius: 5px;
  overflow: hidden;
  min-height: 400px;
}

.menu-lateral {
  width: 180px;
  flex-shrink: 0;
  background: #362065;
}

.item-lateral {
  padding: 12px 16px;
  color: white;
  font-size: 0.9rem;
  cursor: pointer;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
  transition: background-color 0.2s ease;
}

.item-lateral:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.item-lateral.ativo {
  background-color: white;
  color: #362065;
  font-weight: 600;
}

.conteudo-central {
  flex: 1;
  background: #1a0f3e;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  max-height: 800px;
  scroll-behavior: smooth;
}

.noticias-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

/* CARDS DE NOTÍCIA */
.noticia-card {
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  align-items: stretch;
  background: #fff;
  border: 1px solid #e8e5f0;
  box-shadow: 0 2px 8px rgba(45, 26, 110, 0.06);
  transition:
    box-shadow 0.2s ease,
    transform 0.15s ease;
}

.noticia-card:hover {
  box-shadow: 0 4px 16px rgba(45, 26, 110, 0.12);
  transform: translateY(-1px);
}

.noticia-card-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 16px 0 16px 16px;
  flex-shrink: 0;
}

.noticia-thumb-left {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  border: 2px solid #e8e5f0;
}

.noticia-card-center {
  flex: 1;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.noticia-card-right {
  display: flex;
  align-items: center;
  padding: 16px;
  flex-shrink: 0;
}

.titulo-noticia {
  color: #1a1a2e;
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.3;
}

.badge {
  padding: 5px 14px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 700;
  flex-shrink: 0;
  white-space: nowrap;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.badge.pendente {
  background: #fff3e0;
  color: #e65100;
  border: 1px solid #ffcc80;
}

.badge.aprovada {
  background: #e8f5e9;
  color: #2e7d32;
  border: 1px solid #a5d6a7;
}

.badge.rejeitada {
  background: #ffebee;
  color: #c62828;
  border: 1px solid #ef9a9a;
}

.btn-detalhes {
  background: #362065;
  color: white;
  border: none;
  padding: 8px 20px;
  border-radius: 6px;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  flex-shrink: 0;
  transition:
    background-color 0.2s ease,
    transform 0.1s ease;
  white-space: nowrap;
}

.btn-detalhes:hover {
  background: #48298a;
  transform: scale(1.03);
}

.noticia-desc {
  font-size: 0.85rem;
  color: #555;
  margin: 0;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.noticia-card-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: auto;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.tag {
  padding: 2px 10px;
  background: #f0edf8;
  border: 1px solid #d6cef0;
  border-radius: 12px;
  font-size: 0.73rem;
  color: #48298a;
  font-weight: 500;
}

.noticia-autor {
  font-size: 0.8rem;
  color: #888;
  flex-shrink: 0;
}

/* CARREGAR MAIS */
.carregar-mais-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px 0 4px;
}

.btn-carregar-mais {
  background: #48298a;
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.25);
  padding: 10px 32px;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    transform 0.1s ease;
  min-width: 160px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-carregar-mais:hover:not(:disabled) {
  background: #5a3ea7;
  transform: translateY(-1px);
}

.btn-carregar-mais:active:not(:disabled) {
  transform: translateY(0);
}

.btn-carregar-mais:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.info-paginacao {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.5);
}

.fim-lista {
  text-align: center;
  padding: 16px 0 4px;
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.4);
}

/* LOADING DOTS */
.loading-dots {
  display: flex;
  gap: 5px;
  align-items: center;
}

.loading-dots span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: white;
  animation: bounce 0.6s infinite alternate;
}

.loading-dots span:nth-child(2) {
  animation-delay: 0.2s;
}

.loading-dots span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {
  from {
    opacity: 0.3;
    transform: translateY(0);
  }
  to {
    opacity: 1;
    transform: translateY(-4px);
  }
}

/* ESTADOS VAZIOS */
.secao-vazia,
.sem-noticias {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.95rem;
}

.spinner-noticias {
  text-align: center;
  padding: 40px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.95rem;
}

.spinner {
  text-align: center;
  padding: 20px;
  font-size: 1.2rem;
  color: #362065;
}

/* RESPONSIVO */
@media (max-width: 768px) {
  .central-layout {
    flex-direction: column;
  }

  .menu-lateral {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  .item-lateral {
    flex: 1 1 33%;
    border-right: 1px solid rgba(255, 255, 255, 0.1);
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .conteudo-central {
    max-height: 70vh;
  }

  .item {
    flex: 1 1 50%;
    min-width: 120px;
  }

  #menus .item a {
    padding: 10px 8px;
    font-size: 0.9rem;
  }

  #titulo h2 {
    font-size: 1.6rem;
  }

  #titulo h4 {
    font-size: 0.9rem;
  }
}

@media (max-width: 576px) {
  #menus {
    flex-direction: column;
    border-top: none;
  }

  .item {
    flex: 1;
    min-width: 100%;
    border-bottom: 1px solid #ddd;
  }

  #menus .item a {
    padding: 12px 15px;
    font-size: 1rem;
    border-right: none;
    border-bottom: 1px solid white;
  }

  .menu-lateral {
    flex-direction: column;
  }

  .item-lateral {
    flex: unset;
  }

  #conteudo-dinamico {
    padding: 0 15px;
  }
}
/* SEÇÃO USUÁRIOS - REDESIGN */
.usuarios-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.titulo-gerenciamento {
  text-align: center;
  margin-bottom: 24px;
  margin-top: 8px;
}

.titulo-gerenciamento h3 {
  color: white;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 8px 0;
  letter-spacing: 0.5px;
}

.titulo-gerenciamento p {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.9rem;
  margin: 0;
}

.tabelas-grid {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 0;
  align-items: stretch;
  min-height: 400px;
}

/* PAINEL DE TABELA */
.tabela-painel {
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.04);
  overflow: hidden;
  transition:
    border-color 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.tabela-painel.drag-over {
  border-color: #7c3aed;
  box-shadow:
    inset 0 0 24px rgba(124, 58, 237, 0.15),
    0 0 16px rgba(124, 58, 237, 0.2);
}

.painel-header {
  padding: 16px;
  background: #2d1a6e;
  border-bottom: 2px solid rgba(124, 58, 237, 0.4);
}

.painel-titulo {
  color: white;
  font-size: 0.95rem;
  font-weight: 700;
  margin: 0;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.painel-filtro {
  padding: 12px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.tabela-scroll {
  flex: 1;
  overflow-y: auto;
  max-height: 350px;
  scrollbar-width: thin;
  scrollbar-color: rgba(124, 58, 237, 0.4) transparent;
}

.tabela-scroll::-webkit-scrollbar {
  width: 6px;
}

.tabela-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.tabela-scroll::-webkit-scrollbar-thumb {
  background: rgba(124, 58, 237, 0.4);
  border-radius: 3px;
}

.painel-footer {
  padding: 12px 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

/* INSTRUÇÕES CENTRAIS */
.instrucoes-drag {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px 16px;
  gap: 24px;
  min-width: 140px;
}

.instrucao-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
}

.instrucao-item .seta {
  font-size: 1.8rem;
  color: #7c3aed;
  font-weight: 700;
  line-height: 1;
}

.instrucao-item p {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
  max-width: 120px;
  line-height: 1.4;
}

.instrucao-item p strong {
  color: rgba(255, 255, 255, 0.8);
}

.instrucao-separador {
  width: 40px;
  height: 1px;
  background: rgba(255, 255, 255, 0.15);
}

/* DRAG STYLES */
.tabela-usuarios tbody tr[draggable="true"] {
  cursor: grab;
  transition:
    opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1),
    background 0.15s ease;
}

.tabela-usuarios tbody tr[draggable="true"]:active {
  cursor: grabbing;
}

.tabela-usuarios tbody tr.dragging {
  opacity: 0.4;
}

.linha-pendente-promover {
  background: rgba(124, 58, 237, 0.15) !important;
  border-left: 3px solid #7c3aed;
}

.linha-pendente-remover {
  background: rgba(239, 68, 68, 0.12) !important;
  border-left: 3px solid #ef4444;
}

/* BOTOES ACAO */
.botoes-acao {
  display: flex;
  width: 100%;
  gap: 8px;
}

.btn-cancelar-mudancas {
  background: transparent;
  color: rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 10px 16px;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
}

.btn-cancelar-mudancas:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.1);
  color: white;
}

/* BOTÃO SALVAR MUDANÇAS */
.btn-salvar-mudancas {
  background: #ef4444;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition:
    background 0.2s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.1s ease;
  width: 100%;
}

.btn-salvar-mudancas:hover:not(:disabled) {
  background: #dc2626;
  transform: translateY(-1px);
}

.btn-salvar-mudancas.promover {
  background: #7c3aed;
}

.btn-salvar-mudancas.promover:hover:not(:disabled) {
  background: #6d28d9;
}

.btn-salvar-mudancas:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* BUSCA (mantém estilos existentes, só refinamentos) */
.busca-campo {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 6px;
  padding: 0 12px;
  width: 100%;
}

.busca-campo input {
  background: transparent;
  border: none;
  outline: none;
  color: white;
  font-size: 0.85rem;
  padding: 8px 0;
  width: 100%;
}

.busca-campo input::placeholder {
  color: rgba(255, 255, 255, 0.4);
}

.busca-campo select {
  background: transparent !important;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  color: white;
  font-size: 0.85rem;
  padding: 8px 28px 8px 0;
  width: 100%;
  cursor: pointer;
  appearance: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='rgba(255, 255, 255, 0.6)' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'></polyline></svg>") !important;
  background-repeat: no-repeat !important;
  background-position: right 8px center !important;
}

.busca-campo select:focus {
  outline: none !important;
  border: none !important;
  box-shadow: none !important;
}

.busca-campo select::-ms-expand {
  display: none;
}

.busca-campo select option {
  background: #1a0f3e;
  color: white;
}

/* TABELA (mantém) */
.tabela-container {
  overflow-x: auto;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.tabela-usuarios {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.82rem;
}

.tabela-usuarios thead th {
  background: #2d1a6e;
  color: white;
  padding: 10px 12px;
  text-align: left;
  font-weight: 600;
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(255, 255, 255, 0.15);
  white-space: nowrap;
  position: sticky;
  top: 0;
  z-index: 1;
}

.tabela-usuarios tbody tr {
  background: rgba(255, 255, 255, 0.03);
  transition: background 0.15s ease;
}

.tabela-usuarios tbody tr:hover {
  background: rgba(255, 255, 255, 0.08);
}

.tabela-usuarios tbody tr:nth-child(even) {
  background: rgba(255, 255, 255, 0.05);
}

.tabela-usuarios tbody tr:nth-child(even):hover {
  background: rgba(255, 255, 255, 0.1);
}

.tabela-usuarios td {
  padding: 8px 12px;
  color: rgba(255, 255, 255, 0.85);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  white-space: nowrap;
}

.celula-regras {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
}

.badge-regra {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

.badge-coordenador {
  background: rgba(124, 58, 237, 0.2);
  color: #c4b5fd;
  border: 1px solid rgba(124, 58, 237, 0.4);
}

.badge-usuario {
  background: rgba(107, 114, 128, 0.2);
  color: #d1d5db;
  border: 1px solid rgba(107, 114, 128, 0.4);
}

.badge-aluno {
  background: rgba(59, 130, 246, 0.2);
  color: #93c5fd;
  border: 1px solid rgba(59, 130, 246, 0.4);
}

.badge-prex {
  background: rgba(217, 119, 6, 0.2);
  color: #fcd34d;
  border: 1px solid rgba(217, 119, 6, 0.4);
}

.badge-coordenadoria {
  background: rgba(5, 150, 105, 0.2);
  color: #6ee7b7;
  border: 1px solid rgba(5, 150, 105, 0.4);
}

.badge-admin {
  background: rgba(239, 68, 68, 0.2);
  color: #fca5a5;
  border: 1px solid rgba(239, 68, 68, 0.4);
}

.badge-lider {
  background: rgba(14, 165, 233, 0.2);
  color: #7dd3fc;
  border: 1px solid rgba(14, 165, 233, 0.4);
}

.badge-default {
  background: rgba(148, 163, 184, 0.2);
  color: #cbd5e1;
  border: 1px solid rgba(148, 163, 184, 0.3);
}

.tabela-vazia {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80px;
  color: rgba(255, 255, 255, 0.4);
  font-size: 0.85rem;
  border: 1px dashed rgba(255, 255, 255, 0.15);
  border-radius: 6px;
  margin: 12px;
}

.importacao-wrapper {
  width: 100%;
}

/* TABELA SEÇÃO (legacy, keeping for other sections) */
.tabela-secao {
  margin-bottom: 20px;
}

.tabela-titulo {
  color: white;
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 10px;
  padding-bottom: 6px;
  border-bottom: 2px solid rgba(124, 58, 237, 0.4);
}

/* RESPONSIVO para tabelas grid */
@media (max-width: 1024px) {
  .tabelas-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .instrucoes-drag {
    flex-direction: row;
    min-width: unset;
    padding: 12px 16px;
  }

  .instrucao-separador {
    width: 1px;
    height: 40px;
  }
}
</style>
